import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ConfigModule } from '../modules/config/config.module';
import { UserRestClient } from './services/user-rest-client.service';
import { UrlParamsModule } from '../modules/url-params/url-params.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppReadyGuard } from './services/app-ready.guard';
import { StoreModule } from '@ngrx/store';
import { reducers } from './core.store';
import { AccountTransformer } from './services/account-transformer.service';
import { LogoService } from './services/logo.service';
import { StatusRestClient } from './services/status-rest-client.service';
import { LoggerService } from './services/logger.service';
import { TokenRestClient } from './services/token-rest-client.service';
import { SourceAppService } from './services/source-app.service';
import { IamoboService } from './services/iamobo.service';
// @ts-ignore
import { version } from '../../../package.json';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    // version of the application for refreshing config file in browser cache
    let ver = version;
    return new TranslateHttpLoader(http, `i18n/`, `.json?v=${ver}`);
}

const COMPONENTS = [];

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        ConfigModule,
        UrlParamsModule,
        HttpClientModule,
        StoreModule.forFeature('core', reducers)
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS
})
export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [ UserRestClient, AppReadyGuard, AccountTransformer, LogoService, StatusRestClient,
                LoggerService, TokenRestClient, SourceAppService, IamoboService]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/core.module.ts